import RadialPercentChart from './RadialPercentChart'

export default RadialPercentChart
